export const COLORS = {
  whiteColor: '#ffffff',
  mainBlueColor: '#005394',
  accentBlueColor: '#009FD1',
  backgroundBlueColor: '#EDF7FB',

  blackColor: '#212121',
  greyColor: '#757575',
  lightGreyColor: '#919191',
  backgroundGreyColor: '#F6F7F8',

  positiveColor: '#258752',
  negativeColor: '#DD1C1A',

  lightGrey100Color: '#919191',
  lightGrey60Color: '#BDBDBD',
  lightGrey30Color: '#DADADA',
  blue200Color: '#004B85',
  blue100Color: '#005394',
  blue60Color: '#0A60A3',
  accentBlue200Color: '#007FA7',
  accentBlue100Color: '#009FD1',
  accentBlue60Color: '#0BABDE'

};

export const platform = {
  desktop: {
    '@media (max-width: 768px)': {
      display: 'none'
    }
  },
  mobile: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'block'
    }
  }
};

export const mobileDeviceStyles = '@media (max-width: 768px)';
